module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.cz/cs_cz/spolecnost/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.cz/cs_cz/spolecnost/legal-info.html",
	"footer.copyright": "&copy; 2018 GROHE ČR s.r.o.",
	"homepage.headline": "Konfigurátor GROHE SmartControl",
	"homepage.introtext": "Jednoduše odpovězte na pár otázek níže a získejte takovou konfiguraci sprchového systému GROHE SmartControl, jaká bude dokonale vyhovovat vašim požadavkům.",
	"homepage.buttonStart": "Spustit",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Zobrazit výsledky",
	"question1.question": "Pro který prostor vaší koupelny hledáte sprchovou konfiguraci?",
	"question1.option1.text": "Do sprchového koutu",
	"question1.option2.text": "Do vany, tj. včetně vanové výpusti",
	"question2.question": "Jaký typ instalace upřednostňujete? Nástěnnou, podomítkovou nebo kombinaci obojího?",
	"question2.option1.text": "Nástěnná: nejjednodušší řešení pro rychlé vylepšení",
	"question2.option2.text": "Kombinace: zatímco potrubí bude ukryto ve stěně, termostatická baterie s přihrádkou budou nástěnné",
	"question2.option3.text": "Podomítková: čistý, minimalistický vzhled, při kterém bude veškerá technologie ukryta ve stěně",
	"question3.question": "Jak byste chtěli svou sprchu ovládat?",
	"question3.option1.text": "Ovladačem SmartControl s termostatickou baterií",
	"question3.option2.text": "Standardní termostatickou baterií",
	"question3.option3.text": "Standardní pákovou baterií",
	"question3.option4.text": "Pomocí přepínače (chci si ponechat stávající baterii)",
	"question4.question": "Co si přejete v rámci sprchy ovládat?",
	"question4.option1.text": "Pouze ruční sprchu",
	"question4.option2.text": "Velkou hlavovou sprchu (150–250 mm) a ruční sprchu",
	"question4.option3.text": "Extra velkou hlavovou sprchu (250–400mm) a ruční sprchu",
	"question4.option4.text": "Velkou hlavovou sprchu (150–250 mm), ruční sprchu a vanovou výpusť",
	"question4.option5.text": "Extra velkou hlavovou sprchu (250–400mm), ruční sprchu a vanovou výpusť",
	"question5.question": "Jaký tvar preferujete?",
	"question5.option1.text": "Čtvercový",
	"question5.option2.text": "Kruhový",
	"question6.question": "Co si přejete ovládat pomocí vašeho nového ovladače SmartControl?",
	"question6.option1.text": "Hlavovou sprchu se dvěma režimy proudu a ruční sprchu",
	"question6.option2.text": "Hlavovou sprchu a ruční sprchu",
	"question6.option3.text": "Pouze ruční sprchu",
	"question6.option4.text": "Hlavovou sprchu se dvěma režimy proudu a ruční sprchu",
	"question6.option5.text": "Hlavovou sprchu, dvě boční sprchy a ruční sprchu",
	"question6.option6.text": "Hlavovou sprchu, ruční sprchu a vanovou výpusť",
	"question6.option7.text": "Ruční sprchu a vanovou výpusť",
	"question6.option8.text": "Pouze vanovou výpusť",
	"question7.question": "Vyberte si barvu",
	"question7.option1.text": "Chrom",
	"question7.option2.text": "Bílá/chrom",
	"question7.option3.text": "Bílá/chrom",
	"question8.question": "Přejete si termostatickou baterii s integrovaným držákem ruční sprchy?",
	"question8.option1.text": "Ano, chci mít držák ruční sprchy integrovaný do baterie",
	"question8.option2.text": "Ne, držák ruční sprchy dokoupím zvlášť",
	"question9.question": "Kam si přejete umístit držák ruční sprchy?",
	"question9.option1.text": "Na sprchovou tyč prostřednictvím posuvného držáku",
	"question9.option2.text": "Pomocí minimalistického držáku ",
	"question10.question": "Přejete si připevnit vaši hlavovou sprchu na stěnu nebo ke stropu?",
	"question10.option1.text": "Nástěnná hlavová sprcha",
	"question10.option2.text": "Stropní hlavová sprcha",
	"results.title": "{productGroupsCount, plural, \none {Váš výsledek} \nother {Vaše výsledky}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pro správnou instalaci budete potřebovat také:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Spustit novou konfiguraci",
	"results.product.number": "Číslo produktu: #{number}",
	"results.product.button.productInformation": "Informace o produktu",
	"results.product.button.dealerLocator": "Najít showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informace o produktu",
	"results.product.dealer": "Najít showroom",
	"hatchModal.title": "Koupit online",
	"hatchModal.btnText": "Koupit online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.cs_cz.json
// module id = 738
// module chunks = 0